import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { addReqiredMessage } from '@/components/slides/DataSummary/util/addRequiredMessage.ts';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useForm } from '@/form/useForm.ts';

export const AddressSummaryFormZA = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({ slideIds: ['address'] });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  // Fields apartment, street, houseno, suburb,  city, pincode, province
  const apartmentField = s.address.fields.find(({ name }) => name === 'apartment');
  const apartmentLabel = translate(apartmentField?.label);

  const streetField = s.address.fields.find(({ name }) => name === 'street');
  const streetLabel = translate(streetField?.label);

  const housenoField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'houseno'),
    message: s.dataSummary.requiredMessage!,
  });
  const housenoLabel = translate(housenoField?.label);

  const suburbField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'suburb'),
    message: s.dataSummary.requiredMessage!,
  });
  const suburbLabel = translate(suburbField?.label);

  const cityField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'city'),
    message: s.dataSummary.requiredMessage!,
  });
  const cityLabel = translate(cityField?.label);

  const pincodeField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'zipcode'),
    message: s.dataSummary.requiredMessage!,
  });
  const pincodeLabel = translate(pincodeField?.label);

  const provinceField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'province'),
    message: s.dataSummary.requiredMessage!,
  });
  const provinceLabel = translate(provinceField?.label);
  const provinceValue =
    translate(provinceField?.options?.find(({ value }) => value == getFieldValue('province'))?.label) ||
    getFieldValue('province');

  // apartment, street, houseno, suburb,  city, pincode, province
  return (
    <div className="summary-card" data-cy={'summary-form-address'}>
      <h2>{translate(s.dataSummary.titles?.address)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{apartmentLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('apartment')}
          {editMode && <EditDataField field={apartmentField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{streetLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('street')}
          {editMode && <EditDataField field={streetField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{housenoLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('houseno')}
          {editMode && <EditDataField field={housenoField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{suburbLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('suburb')}
          {editMode && <EditDataField field={suburbField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{cityLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('city')}
          {editMode && <EditDataField field={cityField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{pincodeLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('zipcode')}
          {editMode && <EditDataField field={pincodeField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{provinceLabel}</div>
        <div className={'value'}>
          {!editMode && provinceValue}
          {editMode && <EditDataField field={provinceField!} slideId={'address'} />}
        </div>
      </div>
    </div>
  );
};
